import { ReactComponent as AddRoomTimeSvg } from "../../assets/images/svgs/addRoomTime.svg";

const AddRoomTimeIcon = ({ className = "", ...props }) => {
  return (
    <AddRoomTimeSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default AddRoomTimeIcon;
